export const REGISTER = '/company/auth/register';
export const LOGIN = '/company/auth/login';
export const VERIFY_OTP = '/company/auth/register/otp';
export const FORGOT_PASSWORD = '/rentee/auth/forgot-password';
export const GET_COMPANY_DASHBOARD = '/company/dashboard';
export const GET_EMPLOYEE_DASHBOARD = '/rentee/dashboard';
export const GET_BUY_PROPERTY = '/admin/property/all';
export const GET_INSPECTED_PROPERTY = '/rentee/property/inspection';
export const GET_SINGLE_PROPERTY = '/rentee/property';
export const BOOK_INSPECTION = '/rentee/property/rent/inspection';
export const RENT_ASSIST = '/rentee/property/payment/init';
export const ALL_EMPLOYEE = '/company/employee';
export const INDIVIDUAL_EMPLOYEE = '/company/employee/employee';
export const GET_WALLET = '/company/wallet';
export const NEWSLETTER = '/subscribe';
export const RESEND_OTP = '/rentee/auth/resend/otp';


export const GET_PROPERTY = '/property';
export const FILTER_PROPERTY = '/properties/filter';
export const WITHDRAW_FUND = '/account/withdraw';
export const NEXT_OF_KIN = '/next-of-kin';
export const USER_DATA = '/user';
export const GET_USER_NOTIFICATION = '/rentee/notification';
export const GET_INVESTMENT_INFO = '/invest';
export const PAYMENT_REQUEST = '/invest/pay';
export const CONTACT_US = '/contact-us';
export const VERIFY_PAYMENT = '/invest/verify';
export const GET_HOME_PROPERTY = 'featured-properties';
export const GET_USER_PROPERTY = 'user/properties';
export const GET_PAYMENT_HISTORY = '/user/transactions/wallet';
export const PAY_WITH_WALLET = '/invest/wallet/pay';
export const CHECK_PAYMENT = '/deposit';
export const VALIDATE_ACCOUNT = '/account/validate';
export const STORE_ACCOUNT = '/account/store';
export const GET_BANKS = '/account/banks';
export const GET_FEES = '/invest/fee';
export const GET_BENEFICIARIES = '/account/beneficiaries';
export const VERIFY_WITHDRAW = '/account/withdraw/verify';


export const EMPLOYEE_REGISTER = '/rentee/auth/register';
export const EMPLOYEE_LOGIN = '/rentee/auth/login';
export const EMPLOYEE_VERIFY_OTP = '/rentee/auth/verify-otp';


export const CHANGE_PASSWORD = '/user/change-password';
export const RESET_PASSWORD = '/rentee/auth/reset-password';
export const VERIFY_PASSWORD_OTP = '/rentee/auth/verify-password-otp';
